import { render, staticRenderFns } from "./CourseWorkload.vue?vue&type=template&id=078718d0&scoped=true"
import script from "./CourseWorkload.vue?vue&type=script&lang=js"
export * from "./CourseWorkload.vue?vue&type=script&lang=js"
import style0 from "./CourseWorkload.vue?vue&type=style&index=0&id=078718d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078718d0",
  null
  
)

export default component.exports